import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const showSubmenu = (elem) => {
  stopElemAnim(elem);

  showElem(elem);
};

const hideSubmenu = (elem) => {
  addCloseElemAnim(elem);

  timeout.id = setTimeout(() => {
    hideElem(elem);
  }, 300);
};

export const initSubmenu = () => {
  const submenuItems = document.querySelectorAll('.nav-submenu-item');

  submenuItems.forEach((submenuItem) => {
    const submenu = submenuItem.querySelector('.submenu');
    const submenuTrigger = submenuItem.querySelector('.nav-submenu-item__link');

    if (!submenu || !submenuTrigger) {
      return;
    }

    const setExpanded = (value) => {
      submenuTrigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    };

    submenuItem.addEventListener('mouseenter', (e) => {
      submenuItem.classList.add('open');
      clearTimeout(timeout.id);
      showSubmenu(submenu);
      setExpanded(true);
    });
    submenuItem.addEventListener('mouseleave', (e) => {
      submenuItem.classList.remove('open');
      hideElem(e.currentTarget.querySelector('.submenu'));
      hideSubmenu(submenu);
      setExpanded(false);
    });

    submenuItem.addEventListener('keydown', (e) => {
      const keyCode = e.code;

      if (
        keyCode === 'Space' ||
        (keyCode === 'Enter' && submenuTrigger.tagName === 'BUTTON')
      ) {
        e.preventDefault();
        clearTimeout(timeout.id);
        if (submenuTrigger.getAttribute('aria-expanded') === 'true') {
          hideSubmenu(submenu);

          setExpanded(false);
        } else {
          showSubmenu(submenu);

          setExpanded(true);
        }
      }
    });

    submenuItem.addEventListener('focusout', (e) => {
      if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
        hideSubmenu(submenu);

        setExpanded(false);
      }
    });
  });
};
